import type { SVGProps } from 'react'
const LineLock = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.0002 6.6665V8.83734C15.9585 9.11234 16.6668 9.99567 16.6668 11.0415V16.0415C16.6668 17.304 15.6377 18.3332 14.3752 18.3332H5.62516C4.36266 18.3332 3.3335 17.304 3.3335 16.0415V11.0415C3.3335 9.9915 4.04183 9.11234 5.00016 8.83734V6.6665C5.00016 3.90817 7.24183 1.6665 10.0002 1.6665C12.7585 1.6665 15.0002 3.90817 15.0002 6.6665ZM13.7502 6.6665C13.7502 4.59984 12.0668 2.9165 10.0002 2.9165C7.9335 2.9165 6.25016 4.59984 6.25016 6.6665V8.74984H13.7502V6.6665ZM14.3752 17.0832C14.9502 17.0832 15.4168 16.6165 15.4168 16.0415V11.0415C15.4168 10.4665 14.9502 9.99984 14.3752 9.99984H5.62516C5.05016 9.99984 4.5835 10.4665 4.5835 11.0415V16.0415C4.5835 16.6165 5.05016 17.0832 5.62516 17.0832H14.3752ZM11.4585 13.5415C11.4585 14.3469 10.8056 14.9998 10.0002 14.9998C9.19475 14.9998 8.54183 14.3469 8.54183 13.5415C8.54183 12.7361 9.19475 12.0832 10.0002 12.0832C10.8056 12.0832 11.4585 12.7361 11.4585 13.5415Z"
			fill="currentColor"
		/>
	</svg>
)
export { LineLock }
